import ProductSelect from '../ProductSelect.vue'
import { required } from 'vuelidate/lib/validators'
import ProductList from './ProductList.vue'
import greaterOrEqualTo from '../../../validators/greaterOrEqualTo'

export default {
  name: 'MultiBuy',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data () {
    return {
      tab: 0,
      promotion: {
        targetMargin: null,
        page: null,
        oncePerDay: null,
        positionOnPage: null,
        customerGroupId: 0,
        requirements: {
          purchasedProducts: [],
          purchasedAmount: null
        },
        rewards: {
          specialUnitPrice: null,
          maxItemsWithSpecialUnitPrice: null
        }
      },
      purchasedProductSelectShown: false
    }
  },
  computed: {
    name () {
      let name = 'Buy '
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X'
      name += ' up to '
      name += this.promotion.rewards.maxItemsWithSpecialUnitPrice ? this.promotion.rewards.maxItemsWithSpecialUnitPrice : 'Y'
      name += ' (PLU) '
      if (this.promotion.rewards.specialUnitPrice) {
        name += 'for '
        name += this.promotion.rewards.specialUnitPrice + ' CAD'
      } else {
        name += ' for reduced price'
      }

      return name
    },

    nameLat () {
      let name = 'Achetez '
      name += this.promotion.requirements.purchasedAmount ? this.promotion.requirements.purchasedAmount : 'X'
      name += " jusqu'à "
      name += this.promotion.rewards.maxItemsWithSpecialUnitPrice ? this.promotion.rewards.maxItemsWithSpecialUnitPrice : 'Y'
      name += ' (PLU) '
      if (this.promotion.rewards.specialUnitPrice) {
        name += 'pour '
        name += this.promotion.rewards.specialUnitPrice + ' CAD'
      } else {
        name += ' de rabais'
      }

      return name
    },

    discountedPriceFormula () {
      return (basePrice) => {
        return this.promotion.rewards.specialUnitPrice ? this.promotion.rewards.specialUnitPrice : 0
      }
    },

    customerMustBuyError () {
      return this.$v.promotion.requirements.purchasedAmount.$error || this.$v.promotion.requirements.purchasedProducts.$error
    },

    customerWillGetError () {
      return this.$v.promotion.rewards.specialUnitPrice.$error
    }
  },

  validations: {
    promotion: {
      requirements: {
        purchasedProducts: {
          required
        },
        purchasedAmount: {
          required
        }
      },
      rewards: {
        specialUnitPrice: {
          required
        },
        maxItemsWithSpecialUnitPrice: {
          greater: greaterOrEqualTo('promotion.requirements.purchasedAmount')
        }
      }
    }
  },

  components: {
    'product-select': ProductSelect,
    'product-list': ProductList
  },

  methods: {
    addPurchasedProduct (product) {
      product.id = product.productID
      product.plu = product.code
      product.regularPrice = product.regionBasePrice
      product.regularCustomerGroupPrice = product.regionCustomerGroupBasePrice
      product.cost = product.regionCost
      this.promotion.requirements.purchasedProducts.push(product)
    },

    hide (event) {
      if (this.purchasedProductSelectShown) {
        event.preventDefault()
      } else {
        this.$emit('hide')
      }
    },

    removePurchasedProduct (item) {
      this.promotion.requirements.purchasedProducts = this.promotion.requirements.purchasedProducts.filter(product => {
        if (item !== product) {
          return product
        }
      })
    },

    reset () {
      this.tab = 0
      this.$v.$reset()
      if (this.value) {
        this.promotion.customerGroupId = this.value.customerGroupId
        this.promotion.targetMargin = this.value.targetMargin
        this.promotion.oncePerDay = this.value.oncePerDay
        this.promotion.requirements.purchasedAmount = this.value.requirements.purchasedAmount
        this.promotion.requirements.purchasedProducts = this.value.requirements.purchasedProducts
        this.promotion.rewards.specialUnitPrice = this.value.rewards.specialUnitPrice
        this.promotion.rewards.maxItemsWithSpecialUnitPrice = this.value.rewards.maxItemsWithSpecialUnitPrice

        // TODO: type missing?
      } else {
        this.promotion = {
          customerGroupId: 0,
          targetMargin: null,
          page: null,
          oncePerDay: 0,
          positionOnPage: null,
          requirements: {
            purchasedProducts: [],
            purchasedAmount: null
          },
          rewards: {
            specialUnitPrice: null,
            maxItemsWithSpecialUnitPrice: null
          }
        }
      }
    },

    savePromotion () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.promotion.hasBeenEdited = true
      this.promotion.name = this.name
      this.promotion.nameLat = this.nameLat
      this.$emit('change', this.promotion)
      this.hide()
    }
  }
}




// WEBPACK FOOTER //
// ./src/views/EditEvent/AddPromotion/MultiBuy.js